import { format } from "date-fns";

type LogDetailPopupProps = {
    data: any,
    setShowModal: (value: boolean) => void,
    showModal: boolean
}

export const LogDetailPopup = ({ data, setShowModal, showModal }: LogDetailPopupProps) => {

    const closeModal = () => {
        setShowModal(false)
    };

    return (
        <div className={`fixed inset-0 p-4 ${showModal ? "flex" : "hidden"} flex-wrap justify-center items-center w-full h-full z-[1000] bg-black bg-opacity-50`}>
            <div className="w-full max-w-2xl bg-white shadow-lg rounded-md px-5 py-4 relative">
                <svg xmlns="http://www.w3.org/2000/svg"
                    className="w-3 cursor-pointer shrink-0 fill-[#333] hover:fill-red-500 float-right" viewBox="0 0 320.591 320.591"
                    onClick={closeModal}>
                    <path
                        d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                        data-original="#000000"></path>
                    <path
                        d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                        data-original="#000000"></path>
                </svg>
                <div className="my-2 text-center">
                    <h4 className="text-xl text-secondary font-semibold">Notification Log Detail</h4>
                    <div className="flex justify-between gap-2 my-4">
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Notification Name</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.notificationName}</span>
                        </div>
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Receiver Name</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.receiverName}</span>
                        </div>
                    </div>

                    <div className="flex justify-between gap-2 my-4">
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Status</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.status}</span>
                        </div>
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Sent By</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.sentBy}</span>
                        </div>
                    </div>

                    <div className="flex justify-between gap-2 my-4">
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Sent At</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.sentAt}</span>
                        </div>
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Delivered At</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.deliveredAt ? format(new Date(data?.deliveredAt), "MM/dd/yyyy hh:mm a") : "No date"}</span>
                        </div>
                    </div>

                    <div className="flex justify-between gap-2 my-4">
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Opened At</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.openedAt ? format(new Date(data?.openedAt), "MM/dd/yyyy hh:mm a") : "No date"}</span>
                        </div>
                        <div className="w-full text-sm">
                            <label className="w-full text-start block text-secondary text-xs">Failed At</label>
                            <span className="w-full text-sm text-black mt-2 inline-block text-left">{data?.failedAt ? format(new Date(data?.failedAt), "MM/dd/yyyy hh:mm a") : "No date"}</span>
                        </div>
                    </div>
                    <div className="flex max-xm:flex-col gap-4 !mt-4">
                        <button
                            type="button"
                            className="px-6 py-2 min-w-[150px] w-full rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                            onClick={closeModal}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}